import { useEffect, useRef, useState } from 'react'
import { loadDraft, saveDraft, type Draft } from '../../db/meta'

/** Per-channel draft persisted in Dexie meta (debounced). */
export function useDraft(channelId: string) {
  const [body, setBody] = useState('')
  const [loaded, setLoaded] = useState<Draft | null>(null)
  const replyRef = useRef<string | null>(null)
  const ready = useRef(false)

  useEffect(() => {
    let cancelled = false
    ready.current = false
    void loadDraft(channelId).then((draft) => {
      if (cancelled) return
      setBody(draft?.body ?? '')
      replyRef.current = draft?.replyToId ?? null
      setLoaded(draft ?? { body: '', replyToId: null })
      ready.current = true
    })
    return () => {
      cancelled = true
    }
  }, [channelId])

  const persist = (nextBody: string, replyToId: string | null) => {
    replyRef.current = replyToId
    if (!ready.current) return
    void saveDraft(channelId, { body: nextBody, replyToId })
  }

  useEffect(() => {
    if (!ready.current) return
    const timer = setTimeout(() => void saveDraft(channelId, { body, replyToId: replyRef.current }), 400)
    return () => clearTimeout(timer)
  }, [body, channelId])

  return { body, setBody, loaded, persist }
}
